// <aptitude-bar-gauge percentage="75.0" bar-class="someBarGaugeClass"/>
//
// You will get a simple bar gauge of the percentage of something.
export const AptitudeBarGaugeComponent = {
  bindings: {
    percentage: '<',
    barClass: '@'
  },
  controller: function () {
    this.generateStyle = function () {
      if (this.percentage != null) {
        return {
          width: this.percentage + '%'
        };
      } else {
        return {
          width: '0%'
        };
      }
    };
  },
  template: `
    <div style="width: 100%; min-height: 10px;">
      <div ng-class="$ctrl.barClass" style="height: 10px;" ng-style="$ctrl.generateStyle()"></div>
    </div>`
};
